import React, { useState, useEffect } from 'react';
import Modal from '../Layout/Modal';
// eslint-disable-next-line no-unused-vars
// import { API_ENDPOINTS } from '../../api/config';
import { useNavigate } from 'react-router-dom';
import ElevatedButton from '../Layout/ElevatedButton';

const CourseDetailsModal = ({ course, onClose, isOpen }) => {
  // eslint-disable-next-line no-unused-vars
  const [summary] = useState(null);
  // eslint-disable-next-line no-unused-vars
  // const [loading, setLoading] = useState(true);
  // eslint-disable-next-line no-unused-vars
  // const [error, setError] = useState(null);
  const [isFlashcardsUnavailableOpen, setIsFlashcardsUnavailableOpen] = useState(false);
  const navigate = useNavigate();

  const flashcardsUnavailableMessage = 'There are no flashcards available for this course yet. You can still create your own deck or import flashcards from Anki, Quizlet, CSV, or TSV on the flashcards page.';

  
  // Removed unused isFlashcardInsight helper function

  useEffect(() => {
    // const fetchCourseDetails = async () => {
    //   if (!course?._id || !isOpen) return;
      
    //   setLoading(true);
    //   setError(null);
      
    //   try {
    //     // API_ENDPOINTS.AI_COURSE_LEARNING_SUMMARY is a function: (id) => url
    //     const url = API_ENDPOINTS.AI_COURSE_LEARNING_SUMMARY(course._id);
        
    //     const response = await fetch(url, {
    //       credentials: 'include',
    //       headers: {
    //         'Content-Type': 'application/json'
    //       }
    //     });

    //     if (!response.ok) {
    //       if (response.status === 404) {
    //         // Course not found or no learning summary available yet
    //         setSummary({
    //           courseId: course._id,
    //           courseName: course.name,
    //           tutorInteractions: 0,
    //           insights: [],
    //           lastActivity: null
    //         });
    //         return;
    //       }
    //       throw new Error(`Failed to fetch course summary: ${response.status}`);
    //     }

    //     const data = await response.json();
    //     setSummary(data);
    //   } catch (err) {
    //     // Handle both network errors and HTTP errors
    //     if (err.message && (err.message.includes('404') || err.message.includes('Not Found'))) {
    //       // If it's a 404, handle gracefully
    //       setSummary({
    //         courseId: course._id,
    //         courseName: course.name,
    //         tutorInteractions: 0,
    //         insights: [],
    //         lastActivity: null
    //       });
    //       return;
    //     }
    //     // Only log errors that are not 404-related
    //     if (!err.message || (!err.message.includes('404') && !err.message.includes('Not Found'))) {
    //       console.error('Error fetching course details:', err);
    //     }
    //     setError(err.message || 'Could not load course summary.');
    //   } finally {
    //     setLoading(false);
    //   }
    // };

    // fetchCourseDetails();
  }, [course, isOpen]);

  // const handleGenerateFlashcards = () => {
  //   // Navigate to AI dashboard with flashcard mode and course context
  //   navigate('/ai', { 
  //     state: { 
  //       preselectedAction: 'flashcards',
  //       courseContext: course 
  //     }
  //   });
  //   onClose();
  // };

  const handleViewFlashcards = () => {
    navigate(`/flashcards?course=${course._id}`);
    onClose();
  };

  // const handleOpenAITutor = () => {
  //   navigate('/ai', { state: { courseContext: course } });
  //   onClose();
  // };

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} title={`${course?.course_code || 'Course'} - Flashcards & Insights`}>
        <div style={{ padding: '1rem' }}>
        {/* {loading ? (
          <div style={{ textAlign: 'center', padding: '2rem', color: 'var(--color-text-secondary)' }}>
            Loading AI tutor insights...
          </div>
        ) : error ? (
          <div style={{ textAlign: 'center', padding: '2rem', color: 'var(--color-status-error)' }}>
            {error}
          </div>
        ) : ( */}
          <>
            <div style={{ marginBottom: '1.5rem', display: 'flex', gap: '0.75rem', flexWrap: 'wrap' }}>
              {/* <ElevatedButton onClick={handleOpenAITutor}>
                Open AI Tutor
              </ElevatedButton> */}
              {/* <ElevatedButton onClick={handleGenerateFlashcards} variant="secondary">
                Generate Flashcards
              </ElevatedButton> */}
              <ElevatedButton onClick={handleViewFlashcards} variant="secondary">
                View Flashcards
              </ElevatedButton>
            </div>

            {/* <div style={{ marginBottom: '2rem' }}>
              <h3 style={{ color: 'var(--color-text)', marginBottom: '1rem' }}>Learning Progress</h3>
              {summary?.insights && summary.insights.filter(i => !isFlashcardInsight(i)).length > 0 ? (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                  {summary.insights.filter(insight => !isFlashcardInsight(insight)).map((insight, index) => (
                    <div key={index} style={{ 
                      padding: '1rem', 
                      background: 'var(--color-background-secondary)', 
                      borderRadius: '8px',
                      borderLeft: `4px solid ${insight.difficulty === 'High' ? 'var(--color-status-error)' : insight.difficulty === 'Medium' ? 'var(--color-status-warning)' : 'var(--color-status-success)'}`
                    }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.5rem' }}>
                        <strong style={{ color: 'var(--color-text)' }}>{insight.topic}</strong>
                        <span style={{ fontSize: '0.8rem', color: 'var(--color-text-muted)' }}>
                          {new Date(insight.date).toLocaleDateString()}
                        </span>
                      </div>
                      <ul style={{ margin: '0.5rem 0 0 1.5rem', color: 'var(--color-text-secondary)' }}>
                        {insight.learningPoints?.map((point, i) => (
                          <li key={i}>{point}</li>
                        ))}
                      </ul>
                    </div>
                  ))}
                </div>
              ) : (
                <div style={{ textAlign: 'center', color: 'var(--color-text-muted)', fontStyle: 'italic' }}>
                  No learning insights recorded yet. Click "Open AI Tutor" above to start building your learning summary for this course.
                </div>
              )}
            </div> */}
            
            {/* <div style={{ marginTop: '2rem', paddingTop: '1rem', borderTop: '1px solid var(--color-border)' }}>
               <h4 style={{ color: 'var(--color-text)', marginBottom: '0.5rem' }}>Course Statistics</h4>
               <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                 <div style={{ background: 'var(--color-background)', padding: '1rem', borderRadius: '8px', textAlign: 'center' }}>
                   <div style={{ fontSize: '1.5rem', fontWeight: 'bold', color: 'var(--color-button-primary)' }}>
                     {summary?.tutorInteractions || 0}
                   </div>
                   <div style={{ fontSize: '0.8rem', color: 'var(--color-text-muted)' }}>AI Tutor Sessions</div>
                 </div>
                 <div style={{ background: 'var(--color-background)', padding: '1rem', borderRadius: '8px', textAlign: 'center' }}>
                   <div style={{ fontSize: '1.5rem', fontWeight: 'bold', color: 'var(--color-button-primary)' }}>
                     {summary?.insights?.filter(i => !isFlashcardInsight(i)).length || 0}
                   </div>
                   <div style={{ fontSize: '0.8rem', color: 'var(--color-text-muted)' }}>Topics Covered</div>
                 </div>
               </div>
            </div> */}
          </>
        {/* )} */}
        </div>
      </Modal>

      <Modal
        isOpen={isFlashcardsUnavailableOpen}
        onClose={() => setIsFlashcardsUnavailableOpen(false)}
        title="Flashcards Unavailable"
        size="medium"
      >
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
          <p style={{ margin: 0, color: 'var(--color-text-secondary)', lineHeight: 1.6 }}>
            {flashcardsUnavailableMessage}
          </p>
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <ElevatedButton onClick={() => setIsFlashcardsUnavailableOpen(false)}>
              OK
            </ElevatedButton>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default CourseDetailsModal;